export default {
  questions: {
    openConversational: {
      openEndPlaceholder: 'Por favor, ingresa tu texto aquí',
      conversationalPlaceholder: 'Por favor, ingresa tu respuesta aquí',
      conversationClosed: 'Conversación cerrada.',
      conversationalDisclaimer: 'Las preguntas de seguimiento serán generadas por IA basándose en tus respuestas.'
    },
    openText: {
      openEndPlaceholder: 'Por favor, ingresa tu texto aquí'
    },
    multiText: {
      fieldPlaceholder: 'Respuesta {number}',
      instruction: 'Escriba al menos {count} respuesta a continuación, una por cuadro de texto | Escriba al menos {count} respuestas a continuación, una por cuadro de texto',
      instructionWithoutMinimum: 'Escriba sus respuestas a continuación, una por cuadro de texto',
      minimumEntries: 'Ingrese al menos {count} respuesta para continuar. | Ingrese al menos {count} respuestas para continuar.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Marca {number}',
        minimumEntries: 'Ingrese al menos {count} marca para continuar. | Ingrese al menos {count} marcas para continuar.'
      }
    },
    multiselect: {
      caption: "Selecciona todo lo que corresponda"
    },
    rankOrder: {
      enterRankOrder: "Ingresa el orden de clasificación",
      placeholder: "Arrastra tus opciones aquí para ordenarlas"
    },
    openNumeric: {
      label: "Abrir campo numérico"
    },
    complete: {
      message: "Gracias por completar esta encuesta."
    },
    openVideo: {
      warning: "Por favor, graba un video antes de continuar.",
      uploadStatusUploading: "Espera mientras procesamos tu video para continuar...",
      uploadStatusSuccess: "Carga exitosa, puedes continuar.",
      uploadStatusError: "La carga no se completó, inténtalo de nuevo."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Ingresa un correo electrónico válido',
      text_invalid_phone: 'Ingresa un número de teléfono válido',
      text_invalid_us_zip: 'Ingresa un código postal válido de EE. UU. (ZIP)',
      text_invalid_ca_postal: 'Ingresa un código postal canadiense válido',
      text_invalid_uk_postal: 'Ingresa un código postal del Reino Unido válido',
      text_invalid_custom: 'Ingresa un {fieldName} válido',
      text_min_chars: 'Ingresa al menos {min} caracteres',
      text_max_chars: 'Ingresa como máximo {max} caracteres',
      text_alpha_not_allowed: 'Solo se permiten caracteres numéricos',
      text_numeric_not_allowed: 'Solo se permiten caracteres alfabéticos'
    },
    external: {
      invalid: 'La respuesta a esta pregunta no es válida.',
      required: 'Esta pregunta es obligatoria.',
      singlechoice_required: 'Por favor, seleccione una opción antes de continuar.',
      numeric_required: 'Por favor, seleccione una calificación antes de continuar.',
      text_required: 'Por favor, introduzca una respuesta antes de continuar.',
      bigtext_required: 'Por favor, introduzca una respuesta antes de continuar.',
      singlechoiceother_incomplete: 'Por favor, introduzca una respuesta antes de continuar.',
      multiselectother_incomplete: 'Por favor, introduzca una respuesta antes de continuar.',
      numeric_invalid: 'Por favor, introduzca un número válido antes de continuar.',
      radiogrid_required: 'Por favor, seleccione una opción para cada fila antes de continuar.',
      incomplete: 'Por favor, conteste a esta pregunta por completo antes de continuar.',
      multiselect_min: 'Seleccione al menos {value} opciones antes de continuar.',
      multiselect_max: 'Seleccione un máximo de {value} opciones antes de continuar.',
      multiselectother_min: 'Seleccione al menos {value} opciones antes de continuar.',
      multiselectother_max: 'Seleccione un máximo de {value} opciones antes de continuar.',
      multiselectgrid_min: 'Seleccione al menos {value} opciones por fila antes de continuar.',
      multiselectgrid_max: 'Seleccione un máximo de {value} opciones por fila antes de continuar.',
      rankorder_min: 'Clasifique al menos {value} elementos antes de continuar.',
      rankorder_max: 'Clasifique un máximo de {value} elementos antes de continuar.'
    }
  }
}
